<template>
  <div class="group-editor">
    <div class="title">{{ group ? '编辑用户群' : '创建用户群' }}</div>
    <div class="content">
      <li>
        <span class="left-label">名称:</span>
        <span class="right-content"
          ><zg-input
            placeholder="用户群名称"
            v-model="name"
            clear-able
          ></zg-input
        ></span>
      </li>
      <li>
        <span class="left-label">颜色:</span>
        <span class="right-content"
          ><el-color-picker size="small" v-model="color"></el-color-picker
        ></span>
      </li>
      <li>
        <span class="left-label">定义:</span>
        <span class="right-content"
          ><user-condition-panel
            ref="groupCondition"
            v-model="conditions"
            v-if="showConditionPanel"
          ></user-condition-panel
        ></span>
      </li>
    </div>
    <div class="footer btn-bar">
      <zg-button size="normal" @click="onCancel">取消</zg-button>
      <zg-button size="normal" type="primary" @click="onSave">保存</zg-button>
      <zg-button size="normal" type="danger" v-if="group" @click="onDel">
        删除
      </zg-button>
    </div>
    <zg-dialog
      title="删除用户分组"
      v-show="showConfirm"
      class="group-del-dialog"
      @cancel="showConfirm = false"
      @confirm="del"
    >
      确认删除此用户分组？
    </zg-dialog>
    <zg-loading v-show="!ready"></zg-loading>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import UserConditionPanel from './conditionPanel'
import { actions } from '../../store/constants'

export default {
  name: 'groupEditor',
  components: { UserConditionPanel },
  props: {
    group: null
  },
  data() {
    let data = {
      conditions: null,
      color: '#8db3e2',
      name: '',
      showConfirm: false,
      showConditionPanel: true
    }
    if (this.group) {
      data.name = this.group.name
      data.color = this.group.color
      data.conditions = this.group.json
    }
    return data
  },
  computed: {
    ...mapState({
      ready(state) {
        return state.eventEnv.ready.list && state.user.ready.propList
      }
    })
  },
  watch: {
    group(group) {
      this.showConditionPanel = false
      this.name = group ? group.name : ''
      this.color = group ? group.color : '#8db3e2'
      this.conditions = group ? group.json : null
      this.$nextTick(() => {
        this.showConditionPanel = true
      })
    }
  },
  beforeCreate() {
    this.$store.dispatch(actions.user.queryPropList)
    this.$store.dispatch(actions.eventEnv.query)
  },
  methods: {
    onCancel() {
      this.$emit('cancel')
    },
    onSave() {
      let valid = this.validate()
      if (!valid.valid) {
        this.$message({
          type: 'error',
          message: valid.errorMsg
        })
        return
      }
      this.$store
        .dispatch(actions.userGroup.checkName, {
          id: this.group ? this.group.id : 0,
          name: this.name
        })
        .then(res => {
          if (res.status === 0) {
            this.submit()
            return
          }
          this.$message({
            message: '用户群名称已经存在',
            type: 'error'
          })
        })
        .catch(err => {
          this.$message({
            message: '名称校验失败',
            type: 'error'
          })
          console.error('名称校验失败', err)
        })
    },
    submit() {
      if (this.inDemoMode()) return
      let group = {
        name: this.name,
        json: this.conditions,
        color: this.color
      }
      if (this.group) {
        group.id = this.group.id
      }
      let trackData = this.getTrackData()
      this.$store
        .dispatch(actions.userGroup.add, group)
        .then(res => {
          window.track('用户群-保存', {
            用户群名称: group.name,
            '新建/修改': this.group ? '修改' : '新建',
            条件个数: trackData.conditionCount,
            并且数: trackData.andCount,
            或者数: trackData.orCount,
            事件条件数: trackData.eventNum,
            属性条件数: trackData.attrNum,
            新增N天事件条件数: trackData.joinTime,
            任意时间条件事件数: trackData.unlimitedTime
          })
          this.$emit('add', res.values.user_group)
        })
        .catch(err => {
          this.$message({
            message: '创建用户群失败',
            type: 'error'
          })
          console.error('创建用户群失败', err)
        })
    },
    onDel() {
      this.showConfirm = true
    },
    del() {
      this.$store
        .dispatch(actions.userGroup.del, this.group.id)
        .then(() => {
          this.$emit('delete')
        })
        .catch(err => {
          this.$message({
            message: '删除失败',
            type: 'error'
          })
          console.error('删除用户群失败', err)
        })
    },
    validate() {
      let result = {
        valid: true,
        errorMsg: ''
      }
      if (!this.name) {
        result = {
          valid: false,
          errorMsg: '群组名称不能为空'
        }
        return result
      }
      result = this.$refs.groupCondition.validate()
      return result
    },
    getTrackData() {
      let conditionCount = 0 // 条件总数
      let attrNum = 0 // 属性条件数
      let eventNum = 0 // 事件条件数
      let orCount = 0 // 或者条件数
      let unlimitedTime = 0 // 任意时间条件事件数
      let joinTime = 0 // 新增n天事件条件数

      this.conditions.forEach(andCondition => {
        conditionCount += andCondition.length
        orCount += andCondition.length - 1
        andCondition.forEach(item => {
          if (item.eventId) {
            eventNum += 1
            if (item.runPeriod.operator === 'unlimited_time') unlimitedTime++
            if (item.runPeriod.operator === 'join_time') joinTime++
          } else {
            attrNum += 1
          }
        })
      })
      return {
        attrNum: attrNum,
        unlimitedTime: unlimitedTime,
        joinTime: joinTime,
        eventNum: eventNum,
        andCount: conditionCount - orCount,
        orCount: orCount,
        conditionCount: conditionCount
      }
    }
  }
}
</script>

<style lang="sass">
@import "styles/editor"
</style>
